import { Card } from 'antd';
import Typography from 'helpers/fonts';
import { formatMoney } from 'helpers/util';
import React from 'react';

export interface QuoteCardInfo {
  title: string;
  options: QuoteCardInfoOption[];
}

export interface QuoteCardInfoOption {
  type: string;
  instanceId: string;
  name: string;
  value: number;
  isFeature: boolean;
}

export interface QuoteCardProps {
  quoteCardInfo: QuoteCardInfo;
}

const QuoteCard: React.FunctionComponent<QuoteCardProps> = ({
  quoteCardInfo,
}) => {
  const { title, options } = quoteCardInfo;

  return (
    <Card
      style={{ margin: '24px 0' }}
      bordered={false}
      bodyStyle={{ padding: 12 }}
      data-testid="quote-card"
    >
      <p>
        <Typography styleid={6}>{title}:</Typography>
      </p>
      {options.map((option, index) => (
        <p
          key={index}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            position: 'relative',
            marginBottom: index === options.length - 1 ? 0 : '1rem',
          }}
        >
          <Typography styleid={8}>{option.name}</Typography>
          <span style={{ marginLeft: '8px' }}>
            <Typography styleid={6} style={{ whiteSpace: 'nowrap' }}>
              {option.value ? formatMoney(option.value) : 'Cost Included'}
            </Typography>
          </span>
        </p>
      ))}
    </Card>
  );
};

export default QuoteCard;
